
import CommonRadioWithLabel from "../../common/CommonRadioButton";
import "./RadioToggle.scss";

const RadioToggle = ({
	checkedArray,
	labelArray,
	valueArray,
	onChangeArray,
	disabledArray,
	className,
}) => (
	<div className={`date-toggle-adjust ${className}`}>
		<CommonRadioWithLabel
			checked={checkedArray?.at(0)}
			value={valueArray?.at(0)}
			onChange={onChangeArray?.at(0)}
			className={`radio-toggle-first ${className || ""}`}
			label={labelArray?.at(0)}
			name={`radio-toggle-${className}`}
			disabled={disabledArray?.at(0)}
			id={`radio-toggle-${className}-first`}
		/>
		<CommonRadioWithLabel
			checked={checkedArray?.at(1)}
			value={valueArray?.at(1)}
			onChange={onChangeArray?.at(1)}
			className={`radio-toggle-second ${className || ""}`}
			label={labelArray?.at(1)}
			name={`radio-toggle-${className}`}
			disabled={disabledArray?.at(1)}
			id={`radio-toggle-${className}-second`}
		/>
	</div>
);

export default RadioToggle;
